<template>
  <div style="padding:15px;" class="containerTable">
    <vxe-toolbar
      id="toolbarId_bc10"
      :custom="{storage: true}"
      export
      :refresh="{query: RefreshList}"
    >
      <template v-slot:buttons>
        <el-button
          v-if="getLimit('problem_search_button')"
          @click="funcFilter"
        >
          查询
        </el-button>
        <el-button
          v-if="getLimit('problem_add_button')"
          @click="funcAdd"
        >
          新增
        </el-button>
        <el-button
          v-if="getLimit('problem_export_button')"
          @click="funcExport"
        >
          导出
        </el-button>
      </template>
    </vxe-toolbar>
    <vxe-table
      ref="xTable"
      border
      resizable
      stripe
      highlight-current-row
      highlight-hover-row
      row-id="id"
      height="80%"
      :loading="loading"
      :data="tableData"
      :sort-config="{ remote: true }"
      export-config
      show-overflow
      align="center"
      @sort-change="sortList"
    >
      <vxe-table-column
        type="checkbox"
        width="60"
        fixed="left"
      />
      <vxe-table-column>
        <vxe-table-column
          field="title"
          title="标题"
          min-width="100"
          sortable
        />
        <template v-slot:header>
          <el-input
            v-model="listQuery.title"
            placeholder="请输入标题"
            clearable
          />
        </template>
      </vxe-table-column>
      <vxe-table-column>
        <vxe-table-column
          field="content"
          title="内容"
          min-width="200"
          sortable
        />
        <template v-slot:header>
          <el-input
            v-model="listQuery.content"
            placeholder="请输入标题"
            clearable
          />
        </template>
      </vxe-table-column>
      <vxe-table-column>
        <vxe-table-column
          field="type"
          title="类别"
          min-width="100"
          :formatter="formatterType"
          sortable
        />
        <template v-slot:header>
          <el-select
            v-model="listQuery.type"
            placeholder="请选择类型"
            style="width: 100%"
            clearable
          >
            <el-option
              v-for="item in typeList"
              :key="item.value"
              :label="item.label"
              :value="item.value"
            />
          </el-select>
        </template>
      </vxe-table-column>
      <vxe-table-column
        
        title="操作"
        fixed="right"
        width="130"
      >
        <template slot-scope="scope">
          <el-tooltip
            v-if="getLimit('problem_edit_button')"
            class="item"
            effect="dark"
            content="编辑"
            placement="top"
          >
            <vxe-button
              type="text"
              @click="funcEdit(scope.row.code)"
            >
              <i class="el-icon-edit" />
            </vxe-button>
          </el-tooltip>
          <el-tooltip
            v-if="getLimit('problem_delete_button')"
            class="item"
            effect="dark"
            content="删除"
            placement="top"
          >
            <vxe-button
              type="text"
              @click="funcDelete(scope.row.code)"
            >
              <i class="el-icon-delete" />
            </vxe-button>
          </el-tooltip>
        </template>
      </vxe-table-column>
    </vxe-table>
    <vxe-pager
      :loading="loading"
      :current-page.sync="listQuery.pageNum"
      :page-size.sync="listQuery.pageSize"
      :page-sizes="Pagingconf"
      :total="listQuery.total"
      :layouts="['PrevJump', 'PrevPage', 'Number', 'NextPage', 'NextJump', 'Sizes', 'FullJump', 'Total']"
      @page-change="handlePageChange"
    />

    <vxe-modal
      v-model="modelAddFlag"
      title="新增"
      width="600"
      height="400"
      resize
    >
      <compAdd
        ref="addRef"
        @fatherAddMethod="fatherAdd"
        @fatherCancelMethod="fatherCancel"
      />
    </vxe-modal>
    <vxe-modal
      v-model="modelEditFlag"
      title="编辑"
      width="600"
      height="400"
      resize
    >
      <compEdit
        ref="editRef"
        @fatherEditMethod="fatherEdit"
        @fatherCancelMethod="fatherCancel"
      />
    </vxe-modal>
  </div>
</template>
<script>
import compAdd from "./components/problemAdd.vue";
import compEdit from "./components/problemEdit.vue";
import request from "@/utils/request";
export default {
  name: "UnitList",
  components: {
    compAdd,
    compEdit
  },

  data() {
    return {
      message: "",
      loading: false,
      tableData: [],
      modelAddFlag: false,
      modelEditFlag: false,
      modelDetailFlag: false,
      copy: false,
      exportObj:{
        exportUrl:"/ntocc-basic-api/problem/exportProblemList",//导出接口
        name:'问题咨询'
        },
      listQuery: {
        code: "",
        title: "",
        content: "",
        type: "",
        pageNum: 1,
        pageSize: 20,
        sortField: "",
        sortType: "",
        total: 0
      },
      // 所属类型
      typeList: [
          {
              label: "常见问题",
              value: 4
          },
          {
              label: "法律咨询",
              value: 5
          }
      ]
    };
  },
  created() {
    this.findList()
  },
  methods: {
    // 翻译类型名称
    formatterType({ cellValue }) {
      const item = this.typeList.find(item => Number(item.value) === cellValue);
      return item ? item.label : "";
    },
    findList() {
      this.loading = true;
      return new Promise(resolve => {
        request({
          url: "/ntocc-basic-api/problem",
          method: "get",
          params: this.listQuery
        }).then(response => {
          this.tableData = response.data.records;
          this.listQuery.total = response.data.total;
          this.loading = false;
          resolve();
        });
      });
    },
    // 添加方法
    funcAdd() {
      this.$refs.addRef.$refs["form"].resetFields()
      this.modelAddFlag = true;
    },
    // 修改方法
    funcEdit(code) {
      this.$refs.editRef.getInfo(code);
      this.modelEditFlag = true;
    },
    // 详情方法
    funcDetail(code) {
      this.$refs.detailRef.getInfo(code);
      this.modelDetailFlag = true;
    },
    // 删除方法
    funcDelete(row) {
      this.$confirm("确认删除吗？")
        .then(_ => {
          request({
            url: `/ntocc-basic-api/problem`,
            method: "delete",
            params: { codes: row }
          }).then(response => {
            this.$message({ message: response.msg, type: "success" });
            this.findList();
          });
        })
        .catch(_ => {});
    },
    // 增加组件的父方法
    fatherAdd() {
      this.modelAddFlag = false;
      this.findList();
    },
    // 编辑组件的父方法
    fatherEdit() {
      this.modelEditFlag = false;
      this.findList();
    },
    // 公共取消
    fatherCancel(modelFlag) {
      switch (modelFlag) {
        case "add":
          this.modelAddFlag = false;
          break;
        case "edit":
          this.modelEditFlag = false;
          break;
        case "detail":
          this.modelDetailFlag = false;
          break;
        default:
      }
    },
    // 设置底部合计
    footerMethod({ columns, data }) {
      return [
        columns.map((column, columnIndex) => {
          if (columnIndex === 0) {
            return "合计";
          }
          if (["pageviews", "forecast"].includes(column.property)) {
            return this.$XEUtils.sum(data, column.property);
          }
          return null;
        })
      ];
    }
  }
};
</script>

<style>


</style>
